export default {
  rounded: {
    borderRadius: 16
  },
  elevation1: {
    boxShadow: '0 0 2px 0 rgb(0 0 0 / 24%), 0 16px 32px -4px rgb(0 0 0 / 24%)'
  }
};
